import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { BasketProvider } from "@/context/BasketContext";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Competitions from "@/pages/Competitions";
import CompetitionDetail from "@/pages/CompetitionDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Basket from "@/pages/Basket";
import HowItWorks from "@/pages/HowItWorks";
import FreeEntry from "@/pages/FreeEntry";
import Terms from "@/pages/Terms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminRaffleForm from "@/pages/admin/AdminRaffleForm";
import AdminEntries from "@/pages/admin/AdminEntries";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminInstagram from "@/pages/admin/AdminInstagram";
import AdminTikTok from "@/pages/admin/AdminTikTok";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function SiteLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BasketProvider>
          <ScrollToTop />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/competitions" element={<Competitions />} />
              <Route path="/competitions/:id" element={<CompetitionDetail />} />
              <Route path="/basket" element={<Basket />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/account" element={<Account />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/free-entry" element={<FreeEntry />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/members" element={<AdminMembers />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
                <Route path="/admin/new" element={<AdminRaffleForm />} />
                <Route path="/admin/:id/edit" element={<AdminRaffleForm />} />
                <Route path="/admin/:id/entries" element={<AdminEntries />} />
                <Route path="/admin/discounts" element={<AdminDiscounts />} />
                <Route path="/admin/instagram" element={<AdminInstagram />} />
                <Route path="/admin/tiktok" element={<AdminTikTok />} />
              </Route>
            </Route>
          </Routes>
          <Toaster theme="dark" position="top-right" richColors />
          </BasketProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
